import React from "react";

const FilterIcon = () => {
  return <span className="icon-icon_filter" />;
};

export default FilterIcon;
